<header class="w-full h-16 bg-white p-2">
  <a href="https://www.beimbenz.de/" aria-label="Zurück zur Beim BENZ Startseite"
  ><img
    src="/logo/beimbenz-gray.png"
    alt="Beim BENZ Logo"
    class="h-full"
  /></a>
  <!--
  <div class="userbar mr-4 hidden">
    <div
      class="border-circle w-3rem h-3rem m-1 flex align-items-center justify-content-center login"
    >
      <i class="pi pi-user border-circle"></i>
    </div>
  </div>-->
</header>
<div role="progressbar" 
     [attr.aria-valuenow]="progressService.progressPercent()" 
     aria-valuemin="0" 
     aria-valuemax="100" 
     [attr.aria-label]="'Buchungsfortschritt: ' + progressService.progressPercent() + ' Prozent'"
     style="width: {{ progressService.progressPercent() }}%" 
     class="h-1 bg-benzGreen-700 flex"></div>
<nav class="w-full p-4 bg-white flex flex-col gap-2" aria-label="Buchungsnavigation">
  <button type="button" (click)="history.back()" class="flex items-center gap-2 bg-transparent border-none cursor-pointer text-left" aria-label="Zurück zur vorherigen Seite">
    <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M18.9999 6.99997H4.41394L9.70694 1.70697L8.29294 0.292969L0.585938 7.99997L8.29294 15.707L9.70694 14.293L4.41394 8.99997H18.9999V6.99997Z" fill="#48433E"/>
    </svg>
    <span>Zurück</span>
  </button>
  <app-progress-info [divider]="true"></app-progress-info>
</nav>
<main class="text-benzGrey-900 max-w-xl mx-auto">
  <router-outlet></router-outlet>
</main>
